
export class BadgeExtension {
}
